import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import Hidden from '@material-ui/core/Hidden';
import moment from 'moment'

import { agreeTermsAndConditionsForSurvey } from '../../actions/survey-actions';
import SurveyHolderDetail from './SurveyHolderDetail'
import { Coin, ProgressBarSurvey } from '../shared/component'

import { SurveyData } from '../../utils/services/cache/ClientCache'
import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'
import { DaysDiff } from '../../utils/helpers/others/UtilsHelper'
import useStylesDialog from '../../styles/components/rewards/stylesRewardShop';
import useStyles from '../../styles/components/survey/stylesSurvey'

const SurveyHolder = ({ survey, surveyId, handleClickSurveyID }) => {
    const classes = useStyles();
    const styles = useStylesDialog();
    const [open, setOpen] = React.useState(false);
    const [showScroll, setShowScroll] = React.useState(false)
    const title = "Terms & Condtions";
    const date = `${survey.startDate.split(' ')[0]} - ${survey.endDate.split(' ')[0]}`
    let today = new Date();
    let surveyEndDate = new Date(ConvertDateString.convertForDatePicker(survey.endDate))
    let surveyStartDate = new Date(ConvertDateString.convertForDatePicker(survey.startDate))
    let missed = [];
    const [openDetail, setOpenDetail] = React.useState(false);
    const totalPoint = survey.totalSectionRewardCoins + survey.completionBonusCoins;
    const total = DaysDiff(surveyStartDate, surveyEndDate);

    let isSurveyOpen = true;
    let milestonePoint;
    let milestonePercent = [];
    let endDateMilestone = [];
    let dateMilestone = [];
    let progressTitle;
    let progressPercent;
    let noreward = survey.surveyMilestoneModels.length <= 0 ? true : false;
    let bonusPoint = [];
    let milestonePoints = [];
    let position = 0

    if (!noreward) {
        survey.surveyMilestoneModels.forEach((element) => {
            let value = element;
            let startDate = new Date(ConvertDateString.convertForDatePicker(value.startDate));
            let endDate = new Date(ConvertDateString.convertForDatePicker(value.endDate));
            let milestoneTotal = DaysDiff(surveyStartDate, endDate);
            milestonePoints.push(value.bonusCoins);
            milestonePercent.push(Math.floor(100 - (((total - milestoneTotal) / total) * 100)));
            endDateMilestone.push(moment(new Date(endDate)).format('DD/MM/YYYY'))
            dateMilestone.push(`${moment(new Date(startDate)).format('DD/MM/YYYY')} - ${moment(new Date(endDate)).format('DD/MM/YYYY')}`)
            let daysLeft = DaysDiff(today, endDate);
            if (today >= startDate && today < endDate) {
                missed.push(false);
                const day = (--daysLeft > 1) ? "days" : "day"
                progressTitle = "Early Completion Bonus : " + daysLeft + " " + day + " left"
                milestonePoint = value.bonusCoins;
                SurveyData.setMilestoneRewardPoint(milestonePoint)
            }
            else if (today < endDate) {
                missed.push(false);
                milestonePoint = value.bonusCoins;
                progressTitle = "Early completion bonus will end in " + daysLeft + " days"
            }  
            else {
                missed.push(true);
                milestonePoint = 0;
            }
            bonusPoint.push((survey.completionBonusCoins + survey.totalSectionRewardCoins + milestonePoint));
        });

        if (missed) {
            let index = missed.findIndex(element => element === false)
            if (index !== -1) {
                position = index + 1
            }
        }
    }

    if (today < surveyStartDate) {
        isSurveyOpen = false;
        let daysLeft = DaysDiff(today, surveyStartDate);
        progressPercent = 0;
        if (daysLeft > 1)
            progressTitle = daysLeft + " more days to start";
        else
            progressTitle = "1 more day to start";
    }
    else if (surveyEndDate > today) {
        let daysLeft = DaysDiff(today, surveyEndDate);
        progressPercent = Math.floor(100 - ((--daysLeft / total) * 100));
        if (missed[missed.length - 1] || noreward) {
            const day = (daysLeft > 1) ? " days" : " day"
            progressTitle = "Survey will close in " + daysLeft + day
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop)
        return () => window.removeEventListener("scroll", checkScrollTop);
    }, []);

    const handleClickOpen = () => {
        handleClickSurveyID(survey.surveyId)
        if (isSurveyOpen) {

            if (!survey.agreeTermsAndConditions) {
                setOpen(true);
            }
            else {
                handleAgree();
            }
        }
    }

    const handleClose = () => setOpen(false);

    const handleAgree = async () => {
        setOpen(false);
        if (!survey.agreeTermsAndConditions) {
            await agreeTermsAndConditionsForSurvey(survey.surveyId);
        }
        SurveyData.setSurveyGroupId(survey.surveyId);
        SurveyData.setGroupCompletionBonusPoint(survey.completionBonusCoins)
        SurveyData.setSurveyName(survey.title)

        survey.date = date
        survey.totalPoint = totalPoint
        survey.progressPercent = progressPercent
        survey.milestonePercent = milestonePercent
        survey.bonusPoint = bonusPoint
        survey.missed = missed
        survey.noreward = noreward
        survey.dateMilestone = dateMilestone
        survey.milestones = {
            bonusPoint: milestonePoints,
            missed: missed,
            getECB: [],
            noreward: noreward,
            dateMilestone: dateMilestone,
        }
        survey.position = position
        setOpenDetail(true)
    };

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false)
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <Accordion
                onClick={() => handleClickOpen()}
                classes={{
                    root: clsx(classes.rootAccordion, openDetail && survey.surveyId === surveyId && classes.active),
                    expanded: classes.expandedAccordion,
                    rounded: classes.roundedAccordion,
                }}
            >
                <AccordionSummary
                    classes={{
                        root: classes.rootAccordionSummary,
                        content: classes.contentAccordionSummary,
                        expanded: classes.expandedAccordionSummary,
                    }}
                >
                    <Grid
                        item xs={12}
                        container
                        justify="center"
                        alignItems="center"
                        classes={{ root: classes.rootGridContent }}
                    >
                        <Grid item xs={12}>
                            <div className={clsx(classes.textTitle)}> {survey.title} </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={clsx(classes.textDescription)}> {date} </div>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            container
                            classes={{ root: classes.containerProrgessBar }}
                        >
                            <Grid item xs={12} classes={{ root: classes.wrapperProrgessBarCoin }}>
                                <div className={clsx(classes.rootCoin)}>
                                    <Coin
                                        coin={totalPoint}
                                        size="medium" />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.rootAccordionDetailsSurvey }}>
                    {openDetail &&
                        <Hidden lgUp>
                            <Grid container>
                                <SurveyHolderDetail survey={survey} setOpenDetail={(show) => setOpenDetail(show)} />
                            </Grid>
                        </Hidden>
                    }
                </AccordionDetails>
            </Accordion>

            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={'sm'}
                open={open}
                onClose={handleClose}
                classes={{ paper: classes.paperDialog }}
            >
                <DialogTitle id="alert-dialog-title" classes={{ root: classes.rootDialogTitle }}>{title}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: survey.termsAndConditions }} />
                </DialogContent>
                <DialogActions classes={{ root: classes.rootDialogAction }}>
                    <Button onClick={() => handleAgree()} className={clsx(styles.buttonDialogConfirm, styles.buttonYes)}>
                        Accept
                </Button>
                    <Button onClick={() => handleClose()} className={clsx(styles.buttonDialogConfirm, styles.buttonCancle)}>
                        Decline
                </Button>
                </DialogActions>
            </Dialog>
            {openDetail && survey.surveyId === surveyId &&
                <Hidden mdDown>
                    <Grid classes={{ root: clsx(classes.layoutDetail, showScroll && classes.layoutDetailSroll) }}>
                        <Grid container>
                            <SurveyHolderDetail survey={survey} setOpenDetail={(show) => setOpenDetail(show)} />
                        </Grid>
                    </Grid>
                </Hidden>}
        </div>
    );
};

export { SurveyHolder as default }

//<ProgressBarSurvey
//    progressPercent={progressPercent}
//    milestonePercent={milestonePercent}
//    bonusPoint={bonusPoint}
//    noreward={noreward}
//    missed={missed}
//    toolTipCoin={true}
//    position={position}
///>